import { Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

import { ToastAlertService } from '@core/services';
import { ThemesModalComponent } from '../../../components';
import { Theme } from '../../../models/theme.model';
import {
  BusinessService,
  ConfigService,
  ThemeService,
} from '../../../services';
import { ModalAlertComponent } from '@shared/components';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { Cookies } from 'typescript-cookie';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { Business } from '@admin/models';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { ChangeLogoComponent } from './change-logo/change-logo/change-logo.component';
@Component({
  selector: 'app-theme',
  templateUrl: './theme.component.html',
  styles: [
    `
      .circle {
        width: 15px;
        height: 15px;
        border: 2px solid white;
        border-radius: 50%;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        margin: 0 auto;
      }
    `,
  ],
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatAutocompleteModule,
    FormsModule,
    AsyncPipe,
    MatInputModule,
    ReactiveFormsModule,
  ],
})
export class ThemeComponent {
  paginatorIntl: MatPaginatorIntl = new MatPaginatorIntl();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  isCreation = true;
  isrole: boolean = false;

  displayedColumns: string[] = [
    'name',
    'title',
    'primary',
    'accent',
    'warn',
    'general',
    'itemNavbar',
    'actions',
  ];
  dataSource: MatTableDataSource<Theme>;
  fielInput!: string;

  private dialog = inject(MatDialog);
  private alertService = inject(ToastAlertService);
  private themeService = inject(ThemeService);
  private destroyRef = inject(DestroyRef);

  private businessId: number | null | undefined;
  public selectedBussines: any;
  public isSysAdmin = inject(ConfigService).isSysAdmin;
  private businessService = inject(BusinessService);
  public bussines: any[] = [];
  myControl = new FormControl('');

  constructor() {
    this.paginatorIntl = new MatPaginatorIntl();
    this.dataSource = new MatTableDataSource();
  }
  ValidBusiness_id(): boolean {
    return this.businessId === null;
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  public selectedBussinesName = '';
  role() {
    const role = Cookies.get('role');
    if (role && role === 'ADMINISTRADOR') {
      this.isrole = true;
    } else {
      this.isrole = false;
    }
  }
  filteredOptions: Observable<Business[]> = new Observable<Business[]>(
    observer => {
      observer.next([]);
    }
  );
  onOptionSelected(value: number, name: string) {
    this.selectedBussines = value;
    this.selectedBussinesName = name;
    this.myControl.setValue(this.selectedBussinesName);
    this.applyFilter();
  }
  applyFilter() {
    const value = this.myControl.value;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(value),
      map(value => this._filter(value))
    );
  }

  ngOnInit(): void {
    this.role();
    this.dataAdmin();
    this.getBusiness();
  }
  dataAdmin() {
    const idROle = Cookies.get('role');
    const business = Cookies.get('bussinesId');
    if (idROle === 'ADMINISTRADOR') {
      if (business != null) {
        this.businessId = parseInt(business.toString());
        this.selectedBussines = this.businessId;
        this.loadThemes();
      } else {
        this.businessId = null;
        this.loadThemesSysAdmin();
      }
    }
  }
  private getBusiness() {
    this.businessService
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.bussines = request.reply;
            this.filteredOptions = this.myControl.valueChanges.pipe(
              startWith(''),
              map(value => this._filter(value))
            );
          }
        },
      });
  }
  private _filter(value: string | null): Business[] {
    const filterValue = (value || '').toLowerCase();
    // Actualiza el valor de búsqueda anterior
    if (!filterValue) {
      return this.bussines;
    }
    return this.bussines.filter(
      bussines =>
        this.removeDiacritics(bussines.name.toLowerCase()).includes(
          this.removeDiacritics(filterValue)
        ) ||
        (bussines.idBusiness !== undefined &&
          bussines.idBusiness.toString().includes(filterValue))
    );
  }
  removeDiacritics(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  loadThemesSysAdmin(): void {
    this.themeService
      .getThemes()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ reply, code, detail }) => {
          if (code === 10000) {
            this.dataSource = new MatTableDataSource<Theme>(reply);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            if (this.paginator) {
              this.paginator._intl.itemsPerPageLabel = 'Registros por página';
              this.paginator._intl.nextPageLabel = 'Página siguiente ';
              this.paginator._intl.previousPageLabel = 'Página anterior';
              this.paginator._intl.firstPageLabel = 'Primera página';
              this.paginator._intl.lastPageLabel = 'Última página';
              // Configuración del texto de la última página
              this.paginator._intl.getRangeLabel = (
                page: number,
                pageSize: number,
                length: number
              ) => {
                if (length === 0 || pageSize === 0) {
                  return `0 de ${length}`;
                }
                length = Math.max(length, 0);
                const startIndex = page * pageSize;
                const endIndex =
                  startIndex < length
                    ? Math.min(startIndex + pageSize, length)
                    : startIndex + pageSize;
                return `${startIndex + 1} - ${endIndex} de ${length}`;
              };
            }
          } else {
            this.alertService.error(detail);
          }
        },
        error: error => {
          this.alertService.error(`Error: ${error}`);
        },
      });
  }

  loadThemes(): void {
    if (this.selectedBussines) {
      this.themeService
        .getThemes(this.selectedBussines)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: ({ reply, code, detail }) => {
            if (code === 10000) {
              const themesArray: Theme[] = Array.isArray(reply)
                ? reply
                : [reply];
              this.dataSource = new MatTableDataSource<Theme>(themesArray);
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              if (this.paginator) {
                this.paginator._intl.itemsPerPageLabel = 'Registros por página';
                this.paginator._intl.nextPageLabel = 'Página siguiente ';
                this.paginator._intl.previousPageLabel = 'Página anterior';
                this.paginator._intl.firstPageLabel = 'Primera página';
                this.paginator._intl.lastPageLabel = 'Última página';
                // Configuración del texto de la última página
                this.paginator._intl.getRangeLabel = (
                  page: number,
                  pageSize: number,
                  length: number
                ) => {
                  if (length === 0 || pageSize === 0) {
                    return `0 de ${length}`;
                  }
                  length = Math.max(length, 0);
                  const startIndex = page * pageSize;
                  const endIndex =
                    startIndex < length
                      ? Math.min(startIndex + pageSize, length)
                      : startIndex + pageSize;
                  return `${startIndex + 1} - ${endIndex} de ${length}`;
                };
              }
            } else {
              this.alertService.error(detail);
            }
          },
          error: error => {
            this.alertService.error(`Error: ${error}`);
          },
        });
    } else {
      this.loadThemesSysAdmin();
    }
  }

  modalTheme(theme?: Theme) {
    let width: string;
    if (window.innerWidth <= 768) {
      width = '90%';
    } else {
      width = '50%';
    }
    const dialogActionDetail = this.dialog.open(ThemesModalComponent, {
      width: width,
      data: theme,
      disableClose: true,
    });
    dialogActionDetail
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) this.loadThemes();
      });
  }
  modalChangeLogo() {
    let width: string;
    if (window.innerWidth <= 768) {
      width = '90%';
    } else {
      width = '50%';
    }
    const foundBusiness = this.bussines.find(
      b => b.idBusiness === this.selectedBussines
    );
    console.log('daatos', foundBusiness);
    const dialogActionDetail = this.dialog.open(ChangeLogoComponent, {
      width: width,
      data: foundBusiness,
      disableClose: true,
    });
    dialogActionDetail
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) this.loadThemes();
      });
  }

  modalDelete(theme: Theme) {
    console.log(theme, 'respuesta');
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: theme.name,
      disableClose: true,
    });
    dialogDelete
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(request => {
        if (request) {
          this.themeService
            .deleteTheme(theme)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: response => {
                console.log(response, 'cual es el error');
                if (response.code === 10000) {
                  this.alertService.sucess('Tema eliminado');
                } else {
                  this.alertService.error(request.detail);
                }
              },
              complete: () => {
                this.loadThemes();
              },
            });
        } else {
          this.alertService.error('El tema no pudo eliminarse');
        }
      });
  }
}
